'use client';

import MuxPlayer from '@mux/mux-player-react';
import Link from 'next/link';
import React from 'react';

interface CardProps {
  desktopImageSrc: string;
  mobileImageSrc: string;
  title: string;
  year: number;
  number: string;
  description: string;
  enableMuxVideo: boolean;
  muxPlaybackId: any;
  baseLink: any;
}

const Card: React.FC<CardProps> = ({
  desktopImageSrc,
  mobileImageSrc,
  title,
  year,
  number,
  description,
  enableMuxVideo,
  muxPlaybackId,
  baseLink,
}) => {
  return (
    <div className="mb-16 w-50">
      <Link href={baseLink}>
        <div className="relative group">
          {enableMuxVideo && muxPlaybackId ? (
            <MuxPlayer
              playbackId={muxPlaybackId}
              autoPlay
              muted
              loop
              playsInline
              streamType="on-demand"
              style={{ aspectRatio: '16 / 9', width: '100%' }}
            />
          ) : (
            <picture className="group-hover:opacity-[0.15] transition-opacity">
              <source srcSet={desktopImageSrc} media="(min-width: 768px)" />
              <img
                src={mobileImageSrc && desktopImageSrc}
                alt={title}
                className="w-full h-full object-cover mix-blend-light"
              />
            </picture>
          )}

          {/* Overlay and Info */}
          <div className="project-title absolute inset-0 !bg-transparent flex items-center justify-center pointer-events-none">
            <h1 className="text-2xl lg:text-[3.438rem] transition-opacity duration-300 font-light">
              {title}
            </h1>
          </div>
        </div>

        <div className="mt-3 text-[#2B332A] text-base font-light">
          <div className="text-[14px] font-light text-[#2a3329] leading-[18px]">
            <p>{title}</p>
            <p>{year}</p>
          </div>
          <div className="flex items-end text-[14px] font-light text-[#2a3329] leading-none">
            <p className="w-[77px]">{number}</p>
            <p className="max-w-[178px] leading-[18px]">{description}</p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
